import { csvUploadMetric } from '../../handoff-metrics/metrics/csv-upload';
import { UnifyMetricDefinition } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

export const csvUploadedMetricDef: UnifyMetricDefinition = {
  id: 'csv_uploaded',
  name: 'CSV Uploaded',
  sectionName: 'CSV Upload',
  allowExceptions: true,
  shouldSkip: (ctx) => {
    const bundleName = ctx.salesforceBundle?.bundleDisplayName;
    return (
      bundleName !== 'Weave Core' &&
      bundleName !== 'Weave Core Elite' &&
      bundleName !== 'Weave Core Pro'
    );
  },
  criteria: [adaptHandoffMetric(csvUploadMetric)],
};
